// =============================================================================
// Pintravel — Client-chosen identifiers
// =============================================================================
// Every create picks its own id before it goes anywhere. That is what makes a
// replay safe: if the request reached the server but the response was lost, the
// retry collides with the row the first attempt created and comes back 409,
// which the sync engine reads as "already applied". Without it, an ambiguous
// failure produces a duplicate — the classic offline bug, and the reason a
// queue cannot be trusted to retry.
//
// It also gives the entity a stable identity while it is still only local, so a
// point created offline and edited offline queue against the same id instead of
// a `temp-...` placeholder the server has never heard of.
//
// Its own module so it can be tested without dragging in React Query.
// =============================================================================

import { v4 as uuidv4 } from 'uuid';

export function withClientId<T extends { id?: string }>(payload: T): T & { id: string } {
  return { ...payload, id: payload.id ?? uuidv4() };
}

export default withClientId;
